const GlobalStyle = {
    global: () => ({
        "*": {
            scrollbarWidth: "thin",
            scrollbarColor: "var(--chakra-colors-primary) transparent",
        },
        "html, body": {
            color: "var(--chakra-colors-contentT20)",
            height: "100%",
            backgroundColor: "var(--chakra-colors-white)",
        },
        "a:hover": {
            color: "var(--chakra-colors-contentT10)",
        },
        ".btn-icon-lg": {
            justifyContent: "center !important",
            padding: "0.75rem !important",
            width: "unset !important",
        },
        ".btn-icon, .btn-icon-md": {
            justifyContent: "center !important",
            padding: "0.625rem !important",
            width: "unset !important",
        },
        ".btn-icon-sm": {
            justifyContent: "center !important",
            padding: "0.5rem !important",
            width: "unset !important",
        },
        ".btn-icon-xs": {
            justifyContent: "center !important",
            padding: "0.325rem !important",
            width: "unset !important",
        },
        ".close-dropdown": {
            display: "none !important",
        },
        ".rotate-180": {
            transform: "rotate(180deg)",
        },
        ".btn-icon-header": {
            width: "1.25rem !important",
            height: "1.25rem !important",
            justifyContent: "center !important",
            padding: "0.1rem !important",
        },
        ".chakra-input__group": {
            minWidth: "unset !important",
        },
        "a.breadcrumb-link:hover": {
            textDecoration: "underline",
        },
        "a.app-parse-link": {
            textDecoration: "underline",
        },
        "a.app-parse-link:hover": {
            color: "var(--chakra-colors-primary)",
            textDecoration: "underline",
        },
        ".leaflet-popup-content": {
            width: "auto !important",
            whiteSpace: "nowrap",
        },
        ".leaflet-container": {
            position: "relative",
            zIndex: "0",
        },
    }),
};

export default GlobalStyle;
